// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-1176209e]{display:none}.wrapper[data-v-1176209e]{padding-top:33px}.wrapper__card[data-v-1176209e]{margin-right:16px}.wrapper__card>div[data-v-1176209e]{height:99%}.wrapper__note[data-v-1176209e]{color:var(--c-grey-600);font-size:var(--font-size--sm);font-style:italic;line-height:20px}@media(min-width:1024px){.wrapper__note[data-v-1176209e]{margin-left:-25px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
